<template>
  <div class="candidats-slide">
    <div class="candidats-slide__rectangle">
      <div class="candidats-slide__rectangle__titre">
        Taux de participation par groupe d’âge: tables d’accueil BVO
      </div>
      <div class="candidats-slide__rectangle__rec2">
        <div
          class="candidats-slide__rectangle__rec2__carre"
          :style="{ backgroundColor: data.color }"
        ></div>
        <div>% inscrits ayant votés</div>
      </div>
    </div>
    <div class="candidats-slide__graph">
      <div class="candidats-slide__graph__chartstyle">
        <ApexChart
          :category="category"
          :categvalues="categvalues"
          :yaxisname="data.yaxisname"
          :barcolor="data.color"
          :value-formatter="data.valueFormatter"
          :percent="data.percent"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ApexChart from '../apexChart.vue'
export default {
  components: {
    ApexChart
  },
  props: {
    data: {
      type: Object,
      default: () => null
    }
  },
  setup(props) {
    const category = props.data.inscrits.map(elem => {
      return elem.categoage
    })
    const categvalues = props.data.inscrits.map(elem => {
      return elem.pourcentage
    })
    return {
      category,
      categvalues
    }
  }
}
</script>

<style lang="scss" scoped>
.candidats-slide {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  // height: 100%;
  &__rectangle {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'SF Pro SemiBold';
    font-size: 1.5rem;
    width: 87.5rem;
    height: 3rem;
    margin-top: 2.188rem;
    padding: 1.25rem 6.75rem;
    border-radius: 0.25rem;
    box-shadow: 0rem 0.938rem 3.75rem -2.188rem rgba(0, 0, 0, 0.52);
    background-color: white;
    &__titre {
      padding-right: 3.75rem;
      white-space: nowrap;
    }
    &__rec2 {
      display: flex;
      align-items: center;
      white-space: nowrap;
      &__carre {
        height: 2.5rem;
        width: 2.5rem;
        margin-right: 1.375rem;
        border-radius: 0.5625rem;
      }
    }
  }
  &__graph {
    margin-top: 1.563rem;
    width: 82.938rem;
    height: 28.625rem;
    &__chartstyle {
      height: 95%;
    }
  }
}
</style>
